import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { AuthProvider } from './context/AuthContext';
import { ContentProvider } from './context/ContentContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Privacy from './pages/Privacy';
import Complaints from './pages/Complaints';
import SimplePage from './pages/SimplePage';
import OurPeople from './pages/OurPeople';
import Insights from './pages/Insights';
import Pricing from './pages/Pricing';
import ArticleDetail from './pages/ArticleDetail';
import CaseStudies from './pages/CaseStudies';
import CaseStudyDetail from './pages/CaseStudyDetail';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import Enquiries from './pages/admin/Enquiries';
import ContentAdmin from './pages/admin/Content';
import TeamAdmin from './pages/admin/Team';
import ArticlesAdmin from './pages/admin/Articles';
import CaseStudiesAdmin from './pages/admin/CaseStudies';
import ChangePassword from './pages/admin/ChangePassword';

function ScrollRevealInit() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('in-view'); });
    }, { threshold: 0.12 });
    const nodes = document.querySelectorAll('.reveal');
    nodes.forEach((n) => observer.observe(n));
    return () => observer.disconnect();
  }, [pathname]);
  return null;
}

const PublicRoutes = () => (
  <Layout>
    <ScrollRevealInit />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/services" element={<Services />} />
      <Route path="/services/:slug" element={<ServiceDetail />} />
      <Route path="/sector/estate-agents" element={<Navigate to="/services/estate-agents" replace />} />
      <Route path="/privacy-policy" element={<Privacy />} />
      <Route path="/complaints" element={<Complaints />} />
      <Route path="/terms-of-business" element={<SimplePage title="Terms of Business" body="Our Terms of Business set out the basis on which Perrin Myddelton provides legal services to clients. The full document will be published here shortly. In the meantime, please contact us for a copy." />} />
      <Route path="/our-people" element={<OurPeople />} />
      <Route path="/insights" element={<Insights />} />
      <Route path="/insights/:slug" element={<ArticleDetail />} />
      <Route path="/case-studies" element={<CaseStudies />} />
      <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/careers" element={<SimplePage title="Careers" body="Join a friendly, forward-thinking firm that invests in its people. Send your CV to careers@pmsolicitors.co.uk." />} />
    </Routes>
  </Layout>
);

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  return (
    <>
      {isAdmin ? (
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="enquiries" element={<Enquiries />} />
            <Route path="content" element={<ContentAdmin />} />
            <Route path="team" element={<TeamAdmin />} />
            <Route path="articles" element={<ArticlesAdmin />} />
            <Route path="case-studies" element={<CaseStudiesAdmin />} />
            <Route path="change-password" element={<ChangePassword />} />
          </Route>
        </Routes>
      ) : (
        <PublicRoutes />
      )}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
            <Shell />
            <Toaster />
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
